export default __webpack_public_path__ + "static/media/SafetyContainers.ee1fa335.jpg";